import { MultiSelect, Select } from "@mantine/core";
import { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import InputField from "../../../components/inputField";
import Page from "../../../components/Page";
import { backendUrl } from "../../../constants";
import jobLogo from "../../../assets/joblogo.jpg";
import { Text, Image } from "@mantine/core";
import { Dropzone, IMAGE_MIME_TYPE } from "@mantine/dropzone";

import "./styles.css";

const Index = ({ profileData, setProfileData }) => {
  const [industry, setIndustry] = useState([]);
  const [company, setCompany] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [files, setFiles] = useState([]);

  //Industry
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}industry/listIndustry`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.industryName };
          setIndustry((inds) => [...inds, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //companiesType
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}lookup/getLookupByType/companyType`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.lookupName };
          setCompany((inds) => [...inds, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //Employees
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}lookup/getLookupByType/employees`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.lookupName };
          setEmployees((inds) => [...inds, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  const previews = files.map((file, index) => {
    const imageUrl = URL.createObjectURL(file);
    return (
      <Image
        key={index}
        src={imageUrl}
        radius="md"
        style={{
          padding: "5px",
          borderRadius: "10px",
          border: "2px solid rgb(0,0,0,0.5)",
        }}
        imageProps={{ onLoad: () => URL.revokeObjectURL(imageUrl) }}
      />
    );
  });

  return (
    <Page
      style={{ backgroundColor: "rgb(248, 248, 248)", padding: "20px 0px" }}
    >
      <div className="profileInfo-main">
        <h2 className="text-dark text-center py-2">Profile Information</h2>
        <div className="main-1">
          <div className="profile-image">
            <div className="d-flex ">
              {files.length > 0 ? (
                previews
              ) : (
                <img
                  src={profileData?.companyLogo || jobLogo}
                  style={{
                    borderRadius: "10px",
                    margin: "auto",
                    maxHeight: "200px",
                    padding: "5px",
                    border: "2px solid rgb(0,0,0,0.5)",
                  }}
                />
              )}
            </div>
            <Dropzone
              accept={IMAGE_MIME_TYPE}
              // onDrop={v=>{setProfileData({...profileData,companyLogo:v.target.files[0]})}}
              onDrop={(v) => {
                setFiles(v);
                setProfileData((profileData) => ({
                  ...profileData,
                  companyLogo: v[0],
                }));
              }}
              maxFiles={1}
              style={{ width: "220px" }}
            >
              <Text align="center">Upload Company Logo</Text>
            </Dropzone>
          </div>
          <div className="info-content">
            <p style={{ margin: "0px", fontWeight: "500" }}>Company Name</p>
            <InputField
              placeholder={"Company Name"}
              style={{ border: "1px solid rgb(0,0,0,0.1)" }}
              value={profileData?.companyName}
              onChange={(v) =>
                setProfileData((profileData) => ({
                  ...profileData,
                  companyName: v.target.value,
                }))
              }
            />
            <p style={{ margin: "0px", fontWeight: "500" }}>Company Tagline</p>
            <InputField
              placeholder={"Company Tagline"}
              style={{ border: "1px solid rgb(0,0,0,0.1)" }}
              value={profileData?.companyTagLine}
              onChange={(v) =>
                setProfileData((profileData) => ({
                  ...profileData,
                  companyTagLine: v.target.value,
                }))
              }
            />
            <MultiSelect
              label="Company Industry"
              placeholder="Select..."
              data={industry}
              defaultValue={profileData?.industries}
              searchable
              maxDropdownHeight={400}
              onChange={(v) =>
                setProfileData((profileData) => ({
                  ...profileData,
                  industries: v.join(","),
                }))
              }
            />
            <p className="note">
              Select up to 6 Industries in which your company provides
              employment
            </p>
            <hr />
            <p style={{ margin: "0px", fontWeight: "500" }}>Primary Focus</p>
            <InputField
              placeholder={"Primary Focus"}
              value={profileData?.primaryFocus}
              onChange={(v) =>
                setProfileData((profileData) => ({
                  ...profileData,
                  primaryFocus: v.target.value,
                }))
              }
              style={{ border: "1px solid rgb(0,0,0,0.1)" }}
            />
            <div className="d-flex row">
              <Select
                label="Employees"
                placeholder="Select..."
                data={employees}
                creatable
                className="col-md-6 h-100"
                maxDropdownHeight={400}
                value={profileData?.employees}
                onChange={(v) =>
                  setProfileData((profileData) => ({
                    ...profileData,
                    employees: v,
                  }))
                }
              />
              <div className="col-md-6">
                <p style={{ margin: "0px", fontWeight: "500" }}>Founded</p>
                <InputField
                  placeholder={"yyyy"}
                  value={profileData?.founded}
                  onChange={(v) =>
                    setProfileData((profileData) => ({
                      ...profileData,
                      founded: v.target.value,
                    }))
                  }
                  style={{ border: "1px solid rgb(0,0,0,0.1)" }}
                />
              </div>
            </div>
            <Select
              label="Company Type"
              placeholder="Select..."
              value={profileData?.companyType}
              data={company}
              creatable
              maxDropdownHeight={400}
              onChange={(v) =>
                setProfileData((profileData) => ({
                  ...profileData,
                  companyType: v,
                }))
              }
            />
            <p style={{ margin: "0px", fontWeight: "500" }}>
              Company Description
            </p>
            <textarea
              placeholder="Company Description"
              rows={5}
              style={{
                border: "1px solid rgb(0,0,0,0.1)",
                borderRadius: "10px",
                padding: "5px",
                outline: "none",
              }}
              value={
                profileData?.companyDescription
                // ||
                // profileData?.companyAbout?.[0]?.companyDescription
              }
              onChange={(v) =>
                setProfileData((profileData) => ({
                  ...profileData,
                  companyDescription: v.target.value,
                }))
              }
            />
          </div>
        </div>
      </div>
    </Page>
  );
};

export default withTranslation()(Index);
